import { useMemo } from "react";
import ChartCanvas from "components/ChartCanvas";
import { toCurrencyFormat } from "helpers/utils";
import paymentHistoriesService from "services/admin/paymentHistoriesService";
import { formatMonthKey, getMonthKeys, useDashboardQuery } from "../dashboard-utils";
import { getPeriodLabel } from "../periods";
import ChartCard from "./ChartCard";
import { barOptions } from "./chartOptions";

const OPTIONS = barOptions((v) => toCurrencyFormat(v, "KZT"));

const RevenueMonthly = ({ month }) => {
  const q = useDashboardQuery(["revenue-monthly", month], async () => (await paymentHistoriesService.getRevenueByMonth({ month })).data);

  // Столбцы строим по выбранному периоду, а не всегда за 12 месяцев —
  // иначе при «За месяц» 11 пустых столбцов выглядят как нулевая выручка.
  const { chartData, total } = useMemo(() => {
    const keys = getMonthKeys(month);
    const rows = Array.isArray(q.data) ? q.data : [];
    const values = keys.map((k) => Number(rows.find((x) => x.month === k)?.sum) || 0);
    return {
      total: values.reduce((a, b) => a + b, 0),
      chartData: {
        labels: keys.map(formatMonthKey),
        datasets: [
          {
            label: "Выручка",
            data: values,
            backgroundColor: "rgba(34, 197, 94, 0.35)",
            hoverBackgroundColor: "rgba(34, 197, 94, 0.6)",
            borderColor: "rgb(34, 197, 94)",
            borderWidth: 1,
            borderRadius: 4,
            maxBarThickness: 48,
          },
        ],
      },
    };
  }, [q.data, month]);

  return (
    <ChartCard
      title="Выручка по месяцам"
      description={total > 0 ? `Итого: ${toCurrencyFormat(total, "KZT")}` : undefined}
      periodLabel={getPeriodLabel(month)}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
      empty={total === 0}
    >
      <ChartCanvas type="bar" data={chartData} options={OPTIONS} height={280} />
    </ChartCard>
  );
};

export default RevenueMonthly;
